module.exports = "<span class=\"glued-right\">\n  <i class=\"icon-calendar\"></i>\n</span>\n<input class=\"form-control\" daterangepicker (selected)=\"selectedDate($event)\" placeholder=\"{{placeholder}}\" [options]=\"options\"\n        [ngStyle]=\"styles\" [ngModel]=\"label\">\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/atoms/date-input/date-input.component.html
// module id = ./src/app/shared/atoms/date-input/date-input.component.html
// module chunks = main